import React from 'react';
import { Button, Collapse, Container, UncontrolledDropdown, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, DropdownItem, DropdownToggle, DropdownMenu, } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { useAuth } from '../Services/AuthContext';
import { useEffect } from 'react';
import Logo from './Cards/Logo';
import { logout, clearFetchCache } from '../utils/Hooks/useLocalStorage';
import { useAlert } from '../Services/AlertContext';

const RELOAD_ATTEMPTED_KEY = 'jb_version_reload_attempted';
const LEGACY_RELOAD_ATTEMPTS_KEY = 'jb_version_reload_attempts';

export const recordVersionReloadAttempt = serverVersion => {
    try {
        localStorage.setItem(RELOAD_ATTEMPTED_KEY, serverVersion);
    } catch (error) {
        console.error('Unable to track version reload:', error);
    }
};

export const wasVersionReloadAttempted = serverVersion => {
    try {
        return localStorage.getItem(RELOAD_ATTEMPTED_KEY) === serverVersion;
    } catch (error) {
        console.error('Unable to read version reload tracking:', error);
        return false;
    }
};

export const clearVersionReloadTracking = () => {
    try {
        localStorage.removeItem(RELOAD_ATTEMPTED_KEY);
        localStorage.removeItem(LEGACY_RELOAD_ATTEMPTS_KEY);
    } catch (error) {
        console.error('Unable to access localStorage for version reload tracking:', error);
    }
};

const LoggedIn = () => {
   
    const [user] = useAuth();

    return <DropdownItem style={{ backgroundColor: '#036caa', color: 'white', padding: '15px' }}>
        <div>{user ? user.role : ""}</div>
        <div>{user ? user.email : ""}</div>
     
    </DropdownItem>

}
const normalizeVersion = version => {
    const parts = String(version || '').split('.');
    return parts.slice(0, 3).join('.');
};

const compareVersions = (left, right) => {
    const leftParts = String(left || '').split('.');
    const rightParts = String(right || '').split('.');
    const length = Math.max(leftParts.length, rightParts.length);

    for (let index = 0; index < length; index += 1) {
        const leftPart = Number(leftParts[index]);
        const rightPart = Number(rightParts[index]);
        const normalizedLeftPart = Number.isFinite(leftPart) ? leftPart : 0;
        const normalizedRightPart = Number.isFinite(rightPart) ? rightPart : 0;

        if (normalizedLeftPart !== normalizedRightPart) {
            return normalizedLeftPart - normalizedRightPart;
        }
    }

    return 0;
};

export const Version = () => {
    const { REACT_APP_VERSION, REACT_APP_NAME } = process.env;
    const [auth] = useAuth();
    const alert = useAlert(); 
    const alertedVersionRef = React.useRef(null);
    const runningVersion = normalizeVersion(REACT_APP_VERSION);
    const serverVersion = normalizeVersion(auth.serverVersion);
    const versionMismatch = Boolean(runningVersion && serverVersion && runningVersion !== serverVersion);
    const serverIsNewer = versionMismatch && compareVersions(serverVersion, runningVersion) > 0;
    const refreshCacheAndReload = async () => {
        console.log('Clearing cache and hard reloading...')
        recordVersionReloadAttempt(serverVersion);

        try {
            clearFetchCache();
            if (window.caches) {
                const names = await caches.keys();
                await Promise.all(names.map(name => caches.delete(name)));
            }
            if (navigator.serviceWorker) {
                // stale service worker keeps serving the old bundle even after caches are cleared, so it must be unregistered too
                const registrations = await navigator.serviceWorker.getRegistrations();
                await Promise.all(registrations.map(registration => registration.unregister()));
            }
        } catch (error) {
            console.error('Error while clearing caches/service workers before reload:', error);
        } finally {
            // ensure the reload always happens even if cache/SW cleanup above fails
            window.location.reload();
        }
    }
    useEffect(() => {
        if (!serverIsNewer) {
            clearVersionReloadTracking();
        }
        // guard against re-alerting on every re-render (e.g. dropdown toggles, auth context updates)
        if (versionMismatch && alertedVersionRef.current !== serverVersion) {
            alertedVersionRef.current = serverVersion;

            const stuck = serverIsNewer && wasVersionReloadAttempted(serverVersion);
            alert({
                title: serverIsNewer ? <h1>New Version</h1> : <h1>Version Mismatch</h1>,
                body: serverIsNewer ? <div>
                    <h2>There is a new version of JetBidders ({serverVersion}).</h2>
                    <h5>Your Version is ({runningVersion}).</h5>
                    {stuck ? <p style={{ marginTop: '10px' }}>
                        If clicking Refresh doesn't resolve this, please press <b>Ctrl + F5</b> (or <b>Cmd + Shift + R</b> on Mac)
                        to force a hard refresh, or clear your browser's cached images/files from your browser history settings.
                    </p> : null}
                </div> : <div>
                    <h2>You are running a newer version ({runningVersion}) than the server ({serverVersion}).</h2>
                    <h5>This may indicate a deployment issue or cached older build.</h5>
                </div>,
                buttons: serverIsNewer ? <Button onClick={refreshCacheAndReload}>Refresh</Button> : null
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [versionMismatch, serverVersion]);
    return<React.Fragment> <DropdownItem style={{ backgroundColor: '#036caa', color: 'white', padding: '15px' }}>
        <div style={{ fontSize: 'smaller' }} >{REACT_APP_NAME} - version: {REACT_APP_VERSION}</div>
        <div style={{ fontSize: 'smaller' }} >Server version: {serverVersion}</div>
        
        <div style={{ fontSize: '5px' }}>React version: {React.version}</div>
    </DropdownItem>

        {serverIsNewer ? <Button onClick={refreshCacheAndReload}>Reload</Button> : null}
    </React.Fragment>
}
const Privacy = () => <div style={{ padding: '15px' }}>
    <div >
    Copyright Avmin {new Date().getFullYear()}
                    </div>
        <div>
        All&nbsp;rights&nbsp;reserved
        </div>
        <div>
            <a href='https://www.avmin.com.au/privacy-policy'>Our Privacy Policy</a>
    </div>
    <div>
        Contact: <a href='tel::1300286462'>1300 286 462</a>
    </div>

</div>
const LogOut = () => {
    const [, dispatch] = useAuth();
    
    const logoutClick = () => {
        dispatch({ type: "removeAuthDetails" });
        logout();
      
    }
    return <DropdownItem style={{ borderTop: 'solid', padding: 0, borderWidth: 2, borderColor: '#036caa' }}>
        <NavLink tag={Link} onClick={logoutClick} className="text-dark" to="#">Logout</NavLink>
    </DropdownItem>
}
const CharterAdminNav = () => {
    return <React.Fragment>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterRequests/Me/Live">Charter Requests</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterShares/Me/Live">Charter Shares</NavLink>
        </NavItem>
    </React.Fragment>
}

const AdminNav = () => {
    return <React.Fragment>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageAdmins">Admins</NavLink>
        </NavItem>
        {false ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageCharterAdmins">CharterAdmins</NavLink>
        </NavItem> : null}
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageSuppliers">Suppliers</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageClients/Clients">Clients</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterRequests/Me/Live">Charter Requests</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterShares/Me/Live">Charter Shares</NavLink>
        </NavItem>
     
       
    </React.Fragment>
}

const NavMenu = ({ heightChanged }) => {
    const [collapsed, setCollapsed] = React.useState(true);
    const [auth] = useAuth();
    const toggleNavbar = () => {
        setCollapsed(!collapsed)
    }


    useEffect(() => {
        heightChanged && heightChanged(collapsed);
    }, [collapsed,heightChanged])



    const SupplierNav = ({ supplierId }) => {
        
        return <React.Fragment>

        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterRequests/Me/Live">Live Charters</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/aircraft">Aircraft</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/documents">Operator Documents</NavLink>
        </NavItem>
       <NavItem>
            <NavLink tag={Link} className="text-dark" to="/insuranceDocuments">Insurance Documents</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/bids">My Past Bids</NavLink>
        </NavItem>

    </React.Fragment>;
    }
    const ClientNav = ({ client, clientDepartment, qGov }) => <React.Fragment>


        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/CharterRequests/Me/Live">Charters</NavLink>
        </NavItem>
        {client ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageDepartments">Departments</NavLink>
        </NavItem> : null}
        {client  ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageStaff">Staff</NavLink>
        </NavItem> : null}

        {qGov ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/CharterShares/Me/Live">Charter Shares</NavLink>
        </NavItem> : null}
      
    </React.Fragment>


    return auth && auth.jwt ? <header >
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" light>
            <Container>

                <NavbarBrand tag={Link} to="/charterRequests/Me/Live" style={{ height: '80px' }}>
                    <Logo size={100} style={{ marginTop: '-10px' }} />
                </NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                    <Nav>
                        {auth.role === "Supplier" ? <SupplierNav supplierId={auth.supplierId} /> : null}
                        {auth.role === "Admin" ? <AdminNav /> : null}
                        {auth.role === "Client" ? <ClientNav qGov={auth.qGov} client /> : null}
                        {auth.role === "ClientDepartment" ? <ClientNav qGov={auth.qGov} clientDepartment /> : null}
                        {auth.role === "ClientStaff" ? <ClientNav qGov={auth.qGov} /> : null}
                        {auth.role === "CharterAdmin" ? <CharterAdminNav qGov={auth.qGov} /> : null}

                    </Nav>
                </Collapse>
                

                {auth.role !== "Supplier"? <NavLink tag={Link} className="text-dark" to="/newCharterRequest"><Button color='primary'>New Charter Request
               </Button></NavLink>
                :null}
               
                <div style={{ marginLeft: 'auto' }}>
                        <UncontrolledDropdown>
                            <DropdownToggle nav caret className="text-dark">My Account</DropdownToggle>
                        <DropdownMenu style={{ padding: 0, borderWidth: 2, borderColor: '#036caa', right: 0, left: 'auto'}}>
                                <LoggedIn />
                                <DropdownItem style={{ padding: 0, borderWidth: 2, borderColor: 'blue' }}>

                                    <NavLink tag={Link} className="text-dark" to="/messageLog">Messages</NavLink>

                                </DropdownItem>
                                {auth.managesWorkflow ? <DropdownItem style={{ padding: 0, borderWidth: 2, borderColor: 'blue' }}>
                                    <NavLink tag={Link} className="text-dark" to="/manageWorkflow">Manage Workflows</NavLink>
                                </DropdownItem> : null}
                                {auth.managesMessages ? <DropdownItem style={{ padding: 0, borderWidth: 2, borderColor: 'blue' }}>
                                    <NavLink tag={Link} className="text-dark" to="/manageMessaging">Manage Messaging</NavLink>
                                </DropdownItem> : null}
                                <DropdownItem style={{ borderTop: 'solid', padding: 0, borderWidth: 2, borderColor: 'blue' }}>


                                    <NavLink tag={Link} className="text-dark" to="/me">My Details</NavLink>

                                </DropdownItem>
                                <LogOut />
                            <Version />
                            <Privacy />
                            </DropdownMenu>
                        </UncontrolledDropdown>
     
                </div>

            </Container>
        </Navbar>
    </header> : null
}
export default NavMenu;